export default "__VITE_ASSET__6haAY4Qi__"